import React from "react";

const icons = {
  'header-user': require('../../assets/icons/header-user.png'),
  'header-setting': require('../../assets/icons/header-setting.png'),
  'header-profile': require('../../assets/icons/header-profile.png'),
  'header-notification': require('../../assets/icons/header-notification.png'),
  'header-my-page': require('../../assets/icons/header-my-page.png'),
  'header-logout': require('../../assets/icons/header-logout.png'),
  'header-tenken': require('../../assets/icons/header-tenken.png'),
  'chevron-down': require('../../assets/icons/chevron-down.png'),
  'slash-divider': require('../../assets/icons/slash-divider.png'),
  'menu-inspection': require('../../assets/icons/menu-inspection.png'),
  'menu-judgment': require('../../assets/icons/menu-judgment.png'),
  'menu-treatment': require('../../assets/icons/menu-treatment.png'),
  'menu-inspection-status': require('../../assets/icons/menu-inspection-status.png'),
  'menu-inspection-sheet': require('../../assets/icons/menu-inspection-sheet.png'),
  'menu-search': require('../../assets/icons/menu-search.png'),
  'menu-master': require('../../assets/icons/menu-master.png'),
  'menu-machine-master': require('../../assets/icons/menu-machine-master.png'),
  'menu-position-master': require('../../assets/icons/menu-position-master.png'),
  'menu-department-master': require('../../assets/icons/menu-department-master.png'),
  'menu-approval-setting': require('../../assets/icons/menu-approval-setting.png'),
  'menu-template-management': require('../../assets/icons/menu-template-management.png'),
  'sidebar-inspection': require('../../assets/icons/sidebar-inspection.png'),
  'sidebar-inspection-active': require('../../assets/icons/sidebar-inspection-active.png'),
  'sidebar-judgment': require('../../assets/icons/sidebar-judgment.png'),
  'sidebar-judgment-active': require('../../assets/icons/sidebar-judgment-active.png'),
  'sidebar-treatment': require('../../assets/icons/sidebar-treatment.png'),
  'sidebar-treatment-active': require('../../assets/icons/sidebar-treatment-active.png'),
  'sidebar-inspection-status': require('../../assets/icons/sidebar-inspection-status.png'),
  'sidebar-inspection-status-active': require('../../assets/icons/sidebar-inspection-status-active.png'),
  'sidebar-inspection-sheet': require('../../assets/icons/sidebar-inspection-sheet.png'),
  'sidebar-inspection-sheet-active': require('../../assets/icons/sidebar-inspection-sheet-active.png'),
  'sidebar-search': require('../../assets/icons/sidebar-search.png'),
  'sidebar-search-active': require('../../assets/icons/sidebar-search-active.png'),
  'sidebar-master-top': require('../../assets/icons/sidebar-master-top.png'),
  'sidebar-master-top-active': require('../../assets/icons/sidebar-master-top-active.png'),
  'menu-user-master-update': require('../../assets/icons/menu-user-master-update.png'),
  'menu-user-master-history-search': require('../../assets/icons/menu-user-master-history-search.png'),
  'menu-user-master-import': require('../../assets/icons/menu-user-master-import.png'),
  'menu-user-master-export': require('../../assets/icons/menu-user-master-export.png'),
  'menu-user-master-search': require('../../assets/icons/menu-user-master-search.png'),
  'sidebar-user-update': require('../../assets/icons/sidebar-user-update.png'),
  'sidebar-user-update-active': require('../../assets/icons/sidebar-user-update-active.png'),
  'sidebar-user-update-history-search': require('../../assets/icons/sidebar-user-update-history-search.png'),
  'sidebar-user-update-history-search-active': require('../../assets/icons/sidebar-user-update-history-search-active.png'),
  'sidebar-user-import': require('../../assets/icons/sidebar-user-import.png'),
  'sidebar-user-import-active': require('../../assets/icons/sidebar-user-import-active.png'),
  'sidebar-user-export': require('../../assets/icons/sidebar-user-export.png'),
  'sidebar-user-export-active': require('../../assets/icons/sidebar-user-export-active.png'),
  'sidebar-user-search': require('../../assets/icons/sidebar-user-search.png'),
  'sidebar-user-search-active': require('../../assets/icons/sidebar-user-search-active.png'),
  'menu-machine-master-update': require('../../assets/icons/menu-machine-master-update.png'),
  'menu-machine-master-history-search': require('../../assets/icons/menu-machine-master-history-search.png'),
  'menu-machine-master-import': require('../../assets/icons/menu-machine-master-import.png'),
  'menu-machine-master-export': require('../../assets/icons/menu-machine-master-export.png'),
  'menu-machine-master-group-update': require('../../assets/icons/menu-machine-master-group-update.png'),
  'sidebar-machine-master-update': require('../../assets/icons/sidebar-machine-master-update.png'),
  'sidebar-machine-master-update-active': require('../../assets/icons/sidebar-machine-master-update-active.png'),
  'sidebar-machine-master-history-search': require('../../assets/icons/sidebar-machine-master-history-search.png'),
  'sidebar-machine-master-history-search-active': require('../../assets/icons/sidebar-machine-master-history-search-active.png'),
  'sidebar-machine-master-import': require('../../assets/icons/sidebar-machine-master-import.png'),
  'sidebar-machine-master-import-active': require('../../assets/icons/sidebar-machine-master-import-active.png'),
  'sidebar-machine-master-export': require('../../assets/icons/sidebar-machine-master-export.png'),
  'sidebar-machine-master-export-active': require('../../assets/icons/sidebar-machine-master-export-active.png'),
  'sidebar-machine-master-group-update': require('../../assets/icons/sidebar-machine-master-group-update.png'),
  'sidebar-machine-master-group-update-active': require('../../assets/icons/sidebar-machine-master-group-update-active.png'),
  'menu-position-master-update': require('../../assets/icons/menu-position-master-update.png'),
  'menu-position-master-history-search': require('../../assets/icons/menu-position-master-history-search.png'),
  'menu-position-master-import': require('../../assets/icons/menu-position-master-import.png'),
  'menu-position-master-export': require('../../assets/icons/menu-position-master-export.png'),
  'sidebar-position-master-update': require('../../assets/icons/sidebar-position-master-update.png'),
  'sidebar-position-master-update-active': require('../../assets/icons/sidebar-position-master-update-active.png'),
  'sidebar-position-master-history-search': require('../../assets/icons/sidebar-position-master-history-search.png'),
  'sidebar-position-master-history-search-active': require('../../assets/icons/sidebar-position-master-history-search-active.png'),
  'sidebar-position-master-import': require('../../assets/icons/sidebar-position-master-import.png'),
  'sidebar-position-master-import-active': require('../../assets/icons/sidebar-position-master-import-active.png'),
  'sidebar-position-master-export': require('../../assets/icons/sidebar-position-master-export.png'),
  'sidebar-position-master-export-active': require('../../assets/icons/sidebar-position-master-export-active.png'),
  'menu-department-master-update': require('../../assets/icons/menu-department-master-update.png'),
  'menu-department-master-history-search': require('../../assets/icons/menu-department-master-history-search.png'),
  'menu-department-master-import': require('../../assets/icons/menu-department-master-import.png'),
  'menu-department-master-export': require('../../assets/icons/menu-department-master-export.png'),
  'sidebar-department-master-update': require('../../assets/icons/sidebar-department-master-update.png'),
  'sidebar-department-master-update-active': require('../../assets/icons/sidebar-department-master-update-active.png'),
  'sidebar-department-master-history-search': require('../../assets/icons/sidebar-department-master-history-search.png'),
  'sidebar-department-master-history-search-active': require('../../assets/icons/sidebar-department-master-history-search-active.png'),
  'sidebar-department-master-import': require('../../assets/icons/sidebar-department-master-import.png'),
  'sidebar-department-master-import-active': require('../../assets/icons/sidebar-department-master-import-active.png'),
  'sidebar-department-master-export': require('../../assets/icons/sidebar-department-master-export.png'),
  'sidebar-department-master-export-active': require('../../assets/icons/sidebar-department-master-export-active.png'),

  'button-add': require('../../assets/icons/button-add.png'),
  'button-reset': require('../../assets/icons/button-reset.png'),
  'button-back': require('../../assets/icons/button-back.png'),

  'template-management-inspection': require('../../assets/icons/template-management-inspection.png'),
  'template-management-update': require('../../assets/icons/template-management-update.png'),
  'template-management-filter': require('../../assets/icons/template-management-filter.png'),
  'inspection-item-network': require('../../assets/icons/inspection-item-network.png'),
  'inspection-item-applicable': require('../../assets/icons/inspection-item-applicable.png'),

  'idea':  require('../../assets/icons/idea.png'),
  'light-bulb': require('../../assets/icons/light-bulb-icon.png'),
};

const isValidHttpUrl = (string) => {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  if (url.protocol === "http" || url.protocol === "https") {
    return true;
  }
  return false;
};

const Icon = ({name, width, height, className, ...rest}) => {
  let src;
  if (isValidHttpUrl(name)) {
    src = name;
  } else if (icons[name]) {
    src = icons[name];
  } else {
    console.warn(`Icon ${name} is not valid and is not defined.`);
    return null;
  }
  const withClassName = width ? `w-[${width}]` : '';
  const heightClassName = height ? `h-[${height}]` : '';
  const iconClassName = `${withClassName} ${heightClassName} ${className || ''}`;
  return <img src={src}
              alt={name}
              className={iconClassName}
              {...rest} />
};

export default Icon;